import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexto/AuthContext';

/**
 * Componente que protege rutas autenticadas
 * Solo permite acceso si isAuthenticated es true
 * De lo contrario redirige a login
 */
export const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, isLoading } = useContext(AuthContext);

    if (isLoading) {
        return (
            <div className="App bg-dark text-white d-flex justify-content-center align-items-center" style={{height: '90vh'}}>
                <p>Verificando sesión...</p>
            </div>
        );
    }

    if (!isAuthenticated) {
        console.log('ProtectedRoute - User not authenticated, redirecting to login');
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
